import { describeResource } from '@siteless/resource';
import { doc, getDoc } from 'firebase/firestore';
import { z } from 'zod';
import { database } from '../config/firebase';

let blocklistConfigSchema = z.object({
  blocklist: z.array(z.string()),
});

let HandleBlocklistResource = describeResource('HandleBlocklist', {
  get: async () => {
    let configDoc = await getDoc(doc(database, 'handle_moderation', 'config'));
    if (!configDoc.exists()) return [];

    let parsed = blocklistConfigSchema.safeParse(configDoc.data());
    if (!parsed.success) return [];

    return parsed.data.blocklist;
  },
});

export default HandleBlocklistResource;
